import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import {IEcommerceData} from '../../IGoogleTagManager';
import ECommerceEventModel from './EcommerceEventModel';
import ECommerceProductDetailsModel from './models/EcommerceProductDetailsModel';

/**
 * Represents ECommerceProductClickEventModel
 */
export default class ECommerceProductClickEventModel extends ECommerceEventModel {
	public ecommerce: IEcommerceData;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		this.ecommerce = {
			click: {
				actionField: {
					list: this.getSource()
				},
				products: [{...new ECommerceProductDetailsModel(managerRepository, data.productData)}]
			}
		};
	}

	/**
	 * Is should be saved
	 * @returns {boolean} Is should be saved
	 */
	isPersistentEvent(): boolean {
		return true;
	}
};
